// Daily challenge modifiers (Phase 6). One per calendar day, picked by the
// date seed — every player gets the same district, modifier and spawn
// sequence for a given date.

export interface DailyModifier {
  id: string;
  name: { en: string; de: string };
  description: { en: string; de: string };
  trafficFactor: number; // Multiplies district trafficDensity
  coinIntervalFactor: number; // Multiplies coin spawn interval
  coinValueFactor: number; // Multiplies coin score value
  shieldCharges: number | null; // Overrides run shield charges (null = default)
  speedBonus: number; // Added to district baseSpeed
}

export const DAILY_MODIFIERS: readonly DailyModifier[] = [
  {
    id: 'rush-hour',
    name: { en: 'Rush Hour', de: 'Rushhour' },
    description: { en: 'Double traffic. Good luck.', de: 'Doppelter Verkehr. Viel Glück.' },
    trafficFactor: 2.0,
    coinIntervalFactor: 1,
    coinValueFactor: 1,
    shieldCharges: null,
    speedBonus: 0,
  },
  {
    id: 'no-shield',
    name: { en: 'No Second Wind', de: 'Kein Second Wind' },
    description: { en: 'One hit ends the run.', de: 'Ein Treffer beendet den Lauf.' },
    trafficFactor: 1,
    coinIntervalFactor: 1,
    coinValueFactor: 1,
    shieldCharges: 0,
    speedBonus: 0,
  },
  {
    id: 'coin-rush',
    name: { en: 'Coin Rush', de: 'Münzregen' },
    description: {
      en: 'Twice the coins, twice the value.',
      de: 'Doppelte Münzen, doppelter Wert.',
    },
    trafficFactor: 1,
    coinIntervalFactor: 0.5,
    coinValueFactor: 2,
    shieldCharges: null,
    speedBonus: 0,
  },
  {
    id: 'fast-start',
    name: { en: 'Fast Start', de: 'Schneller Start' },
    description: { en: 'The run starts at high speed.', de: 'Der Lauf beginnt mit hohem Tempo.' },
    trafficFactor: 1,
    coinIntervalFactor: 1,
    coinValueFactor: 1,
    shieldCharges: null,
    speedBonus: 0.05,
  },
];

export function dailyModifierForSeed(seed: number): DailyModifier {
  return DAILY_MODIFIERS[seed % DAILY_MODIFIERS.length] as DailyModifier;
}

/** Local date as YYYY-MM-DD (daily challenges roll at local midnight). */
export function todayKey(now = new Date()): string {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
